class Login
    constructor: (el) ->
        @.$el = el
        @.$errorEl = @.$el.querySelector '.login__error'
        @.$loginButton = @.$el.querySelector '.login__login-button'
        @.$passwordInputEl = @.$el.querySelector 'input[name="password"]'
        @.$usernameInputEl = @.$el.querySelector 'input[name="username"]'

        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? false

        @.$el.classList.add 'login--bound'
        if @.api && @.apiMethod && @.$loginButton
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$loginButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.SetErrorState false
            self.SendAuth()
            return
        @.$usernameInputEl.addEventListener 'keyup', (e) ->
            self.SetErrorState false
            if e.key == "Enter" || e.keyCode == 13
                self.$loginButton.click()
            return
        @.$passwordInputEl.addEventListener 'keyup', (e) ->
            self.SetErrorState false
            if e.key == "ENTER" || e.keyCode == 13
                self.$loginButton.click()
            return
        return
    
    SendAuth: ->
        if @.api && @.apiMethod
            self = @
            try
                if @.apiMethod == 'POST'
                    body = {
                        username: @.$usernameInputEl.value
                        password: @.$passwordInputEl.value
                    }
                    request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                        , ->
                            if request.responseText && request.responseText != ""
                                try
                                    window.location.reload()
                                catch error
                                    console.log "Fehler beim Versuch die Antwort der Schnittstelle zur Authentifizierung zu verarbeiten"
                                    return
                            else
                                console.log "Die Anfrage an die Schnittstelle zur Authentifizierung lieferte ein leeres Ergebnis"
                        , ->
                            if request.status == 403
                                self.SetErrorState true, "Der Login-Versuch ist leider fehlgeschlagen.<br/><br/>Entweder ist ihr Account noch nicht freigeschaltet, gesperrt oder aber Ihre Eingaben waren nicht korrekt."
                            console.log "Bei der Anfrage an die Schnittstelle zur Authentifizierung ist leider ein Fehler aufgetreten"
                            return
                        , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                console.log "Fehler beim Versuch die Schnittstelle zur Authentifizierung zu ermitteln."
        return
    
    SetErrorState: (show, errorText) ->
        if show
            if errorText && errorText != ''
                @.$errorEl.innerHTML = errorText
                @.$el.classList.add 'login--error'
        else
            @.$errorEl.innerHTML = ""
            @.$el.classList.remove 'login--error'
        return

BindLogins = ->
    document.querySelectorAll '.login:not(.login--bound)'
        .forEach (el) ->
            new Login el
            return
    return

window.addEventListener 'bind-components', BindLogins